export enum OutlineCommentsEnum {
    OUTLINE = 'OUTLINE',
    COMMENTS = 'COMMENTS',
    SETTINGS = 'SETTINGS'
}
